module.exports = __webpack_public_path__ + "img/sand-decal-29.33b81823.png";